import {anyArray, dataMember, required, typedArray} from 'santee-dcts';
import { siteDisplayNameRenderer } from '../../../renderer/site-display-name-renderer';
import { Distance } from '../../../shared';
import { EQueryStatus } from '../../../e-queries/models/e-query-status';
import { AgeInfo } from '../../../e-queries/age-info';
import * as moment from 'moment';
import { deserializers } from '../../../core';

export class EQuerySummary implements AgeInfo {
    @dataMember()
    @required()
    public eQueryId: number;

    @dataMember()
    @required()
    public accessionNumber: string;

    @dataMember()
    @required()
    public projectNumber: string;

    @dataMember()
    @required()
    public siteName: string;

    @dataMember()
    @required()
    public siteNumber: string;

    @dataMember()
    @required({ nullable: true })
    public eQueryStatus: EQueryStatus;

    @dataMember()
    @required()
    public eQueryAge: Distance;

    @dataMember()
    @required()
    public protocolName: string;

    @dataMember()
    @required()
    public sponsorName: string;

    @dataMember({ customDeserializer: deserializers.deserializeDate })
    @required({ nullable: true })
    public visitCollectionDate: moment.Moment;

    @dataMember()
    @required({ nullable: true })
    @anyArray()
    public responders: string[];

    @dataMember({ customDeserializer: deserializers.deserializeDate })
    @required({ nullable: true })
    public responseDateTime: moment.Moment;

    public get siteDisplayName(): string {
        return siteDisplayNameRenderer({siteNumber: this.siteNumber, investigatorFullName: this.siteName});
    }
}

export class EQueriesSummariesReadModel {
    @dataMember()
    @required()
    @typedArray(EQuerySummary)
    public eQueries: EQuerySummary[];
}
